<template>
  <div class="modalAdd">
    <b-modal id="modalViewFile" ref="modalViewFile" centered scrollable  size="lg" modal-class="modal-no-border modal-viewFile" no-close-on-backdrop>
      <template v-slot:modal-header="{close}">
        <!-- Emulate built in modal header close button action -->
        <div class="title-modal text-center w-100 ">
          <div class="btn-closeModal btn-closeModal-view" @click="hideModalViewFile">
            <svg height="329pt" viewBox="0 0 329.26933 329" width="329pt" xmlns="http://www.w3.org/2000/svg"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/></svg>
          </div>
        </div>
      </template>
      <div class="scroll-bar view-file-bg">
        <img :src="detailFile.storage_url" style="max-height: 80vh;" v-if="isImage(detailFile.media_type_id)"/>
      </div>
      <div class="view-file-video">
        <video width="100%" controls controlsList="nodownload" :src="detailFile.storage_url" v-if="isVideo(detailFile.media_type_id)">
        </video>
      </div>
      <object :data="detailFile.storage_url" type="application/pdf" v-if="isPDF(detailFile.media_type_id)">
        <iframe :src="detailFile.storage_url" type="application/pdf">
          <p><a :href="detailFile.storage_url">Download PDF</a></p>
        </iframe>
      </object>
    </b-modal>
  </div>
</template>

<script>
import { BModal, VBModal } from 'bootstrap-vue'
import {MEDIA_TYPE} from '@/utils/constant'
import {mapState} from 'vuex'
export default {
  name: 'ViewFile',
  components: {
    'b-modal': BModal
  },
  directives: {
    // Note that Vue automatically prefixes directive names with `v-`
    'b-modal': VBModal
  },
  methods: {
    hideModalViewFile () {
      if (this.detailFile) {
        this.$store.commit('employeeFolder/CHANGE_DETAIL_FILE', '')
      }
      this.$refs['modalViewFile'].hide()
    },
    isImage (mediaType) {
      return mediaType === MEDIA_TYPE.IMAGE_ROLE_ID
    },
    isVideo (mediaType) {
      return mediaType === MEDIA_TYPE.VIDEO_ROLE_ID
    },
    isPDF (mediaType) {
      return mediaType === MEDIA_TYPE.PDF_ROLE_ID
    },
    closeModal () {
      this.$refs['modalViewFile'].hide()
      this.$store.commit('employeeFolder/CHANGE_DETAIL_FILE', '')
    }
  },
  computed: {
    ...mapState({
      detailFile: state => state.employeeFolder.detailFile
    })
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/stylesheet/vendor/detail_vendor.scss";
@import "@/assets/stylesheet/vendor/uploadfile.scss";
@import "@/assets/stylesheet/mypage/detail_mypage.scss";
</style>



// WEBPACK FOOTER //
// src/views/Employee/FolderManager/ViewFile.vue